<script setup lang="ts">
import type { FooterHeadlineProps } from '@satch-ui/components/footer/types'
import { clsx } from 'clsx'

import { ChevronRightCircleIcon } from '@fond-of/satch-icons'

const props = withDefaults(defineProps<FooterHeadlineProps>(), {
  variant: 'primary',
})
</script>
<template>
  <h4
    :class="
      clsx(
        'font-sans-semi-bold mb-5 inline-flex w-full items-center justify-between text-base !leading-[1.55]',
        {
          'cursor-pointer': !props.disabled,
          'text-primary': variant === 'primary',
          'text-black': variant === 'black',
        }
      )
    "
  >
    {{ props.headline }}
    <ChevronRightCircleIcon
      v-if="!props.disabled"
      :class="[
        'size-7 rotate-90 transition-all ease-in-out group-data-[state=open]:rotate-[270deg]',
        {
          'text-primary': variant === 'primary',
          'text-black': variant === 'black',
        },
      ]"
    />
  </h4>
</template>
